class BoMetaEditorController {
    constructor($sce, $scope) {
        this.sce = $sce;
        this.scope = $scope;
        this.displayAsTextarea = false;

        this.availableCustomTypes = [
            {
                value: 'text',
                label: 'Text'
            },
            {
                value: 'string',
                label: 'String'
            },
            {
                value: 'bool',
                label: 'Boolean'
            },
            {
                value: 'integer',
                label: 'Integer'
            },
            {
                value: 'number',
                label: 'Float'
            },
        ];
        this._initWatchers();
    }

    _initWatchers() {
        this.scope.$watch(() => {
            return this.metaValue;
        }, () => {
            this.onValueChange({
                newValue: this.metaValue,
                metaName: this.metaDefinition.key
            });
        })
    }

    updateMetaValueType(newValue) {
        this.metaValue.type = newValue;
    }

    updateMetaValue(newValue) {
        this.metaValue = newValue;
    }
}

BoMetaEditorController.$inject = [
    '$sce',
    '$scope'
];

angular
    .module('festzelt-os.components')
    .controller('BoMetaEditorController', BoMetaEditorController);



// WEBPACK FOOTER //
// ./src/app/modules/bo/components/meta-editor/controller.js